import React, { useState, useContext } from 'react'
import { MapContainer, TileLayer } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import Markers from './Markers'
import { places } from '../assets/data.json'
import ModalContent from './ModalContent'
import MapContext from '../context/MapContex'
import AdditionalDescription from './AdditionalDescription'

const MapView = () => {
    const { data } = useContext(MapContext)
    console.log(data)
    const [state, setState] = useState({
        currentLocation: { lat: '3.455750192', lng: '-76.54639056' }
    })

    return (
        <MapContainer center={state.currentLocation} zoom={15} className="map">
            <TileLayer
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Markers data={places} />
            {data.length > 0 && <ModalContent className="modal_visible" data={data} />}
            {data.length > 0 && <AdditionalDescription className="description_visible" data={data} />}

        </MapContainer>
    )
}

export default MapView
